const data = {
    "projects" :[
        {
            "title" : "Portfolio Website",
            "desc" : "My newest and most important project so far. I built this clean and minimilistic website to tell the world a little bit about myself. I designed this website by myself on figma. I have written clean code that can be easily be modified to accomodate all the achievements that are yet to come.",
            "img" : "PortfolioWebsite",
            "urlSource" : "https://github.com/MihirMulay2001/portfolio-website",
            "urlWebsite" :"https://mihirmulay2001.github.io/portfolio-website/",
            "techStack" : ["ReactJS", "Framer motion"]
        },
        {
            "title" : "Todo App",
            "desc" : "A beautiful and easy to use ToDo app that helps you organize your tasks efficiently and be more productive. It groups tasks into 2 sections - pending tasks and completed tasks.",
            "img" : "TodoApp",
            "urlWebsite" : "https://mihirmulay2001.github.io/todo-app/",
            "urlSource" : "https://github.com/MihirMulay2001/todo-app",
            "techStack" : ["ReactJS" , "Bootstrap"]
        },
        {
            "title" : "Weather forecast",
            "desc" : " My very first React project. It is a simple and easy to use weather app that takes in the user’s location and gives the weather for that day and for the following week. I made a minimalistic and user friendly UI by using bootstrap to design the website.",
            "img" : "WeatherForecast",
            "urlWebsite" : "https://mihirmulay2001.github.io/My-Weather-App/",
            "urlSource" : "https://github.com/MihirMulay2001/My-Weather-App",
            "techStack" : ["ReactJS" , "Bootstrap"]
        }
    ]
}

export default data;

/*
{
            "title" : "E-commerce Website",
            "desc" : "A elegant, easy to use E-commerce website. Allows user to browse through a list of items and add them to a cart. and One of my hardest projects so far. Built using React and  Material UI.",
            "img" : "EcommerceWebsite",
            "url" : "https://www.google.com",
            "techStack" :["ReactJS" , "Material UI"]
        },
        */